import React from "react";
import { Link } from "react-router-dom";
import { Phone, CalendarClock } from "lucide-react";
import { useCompany } from "@/context/CompanyContext";
import { trackEvent } from "@/lib/ga";

export default function StickyMobileCta() {
  const { company } = useCompany();
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-50 grid grid-cols-2 border-t border-slate-200 shadow-[0_-4px_16px_rgba(0,0,0,0.08)]" data-testid="sticky-mobile-cta">
      <a
        href={`tel:${company.phone_href || ""}`}
        onClick={() => trackEvent("phone_click", { location: "sticky_bar" })}
        data-testid="sticky-call"
        style={{ paddingBottom: "calc(0.875rem + env(safe-area-inset-bottom))" }}
        className="flex items-center justify-center gap-2 bg-launch text-white font-bold pt-3.5 text-sm"
      >
        <Phone className="h-5 w-5" /> Call Now
      </a>
      <Link
        to="/contact-us"
        onClick={() => trackEvent("schedule_click", { location: "sticky_bar" })}
        data-testid="sticky-book"
        style={{ paddingBottom: "calc(0.875rem + env(safe-area-inset-bottom))" }}
        className="flex items-center justify-center gap-2 bg-navy text-white font-bold pt-3.5 text-sm"
      >
        <CalendarClock className="h-5 w-5" /> Book Online
      </Link>
    </div>
  );
}
